import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const LogoutButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  cursor: pointer;
  min-width: 80px;

  svg path {
    stroke: ${colors.grey11};
  }
`;
